export enum BloodGroups {
  ABNegative = "ABNegative",
  ABPositive = "ABPositive",
  ANegative = "ANegative",
  APositive = "APositive",
  BNegative = "BNegative",
  BPositive = "BPositive",
  ONegative = "ONegative",
  OPositive = "OPositive",
}

export enum Gender {
  FEMALE = "FEMALE",
  MALE = "MALE",
  OTHER = "OTHER",
}

export enum Relation {
  BROTHER = "BROTHER",
  COUSIN = "COUSIN",
  DAUGHTER = "DAUGHTER",
  FATHER = "FATHER",
  GRANDDAUGHTER = "GRANDDAUGHTER",
  GRANDFATHER = "GRANDFATHER",
  GRANDMOTHER = "GRANDMOTHER",
  GRANDSON = "GRANDSON",
  HUSBAND = "HUSBAND",
  ME = "ME",
  MOTHER = "MOTHER",
  OTHER = "OTHER",
  SISTER = "SISTER",
  SON = "SON",
  WIFE = "WIFE",
}

export enum PATIENT_ADDRESS_TYPE {
  HOME = "HOME",
  OFFICE = "OFFICE",
  OTHER = "OTHER",
}

export enum CouponApplicable {
  APPLIED = "APPLIED",
  ITEM_AT_HIGHER_DISCOUNT = "ITEM_AT_HIGHER_DISCOUNT",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}

export enum PLAN_ID {
  CIRCLEPlan = "CIRCLEPlan",
}

export enum CART_SOURCE {
  CARE_PERSONA = "CARE_PERSONA",
  NA = "NA",
  WHATSAPP_REMINDER = "WHATSAPP_REMINDER",
  RE_ORDER_REMINDER = "RE_ORDER_REMINDER",
}

export enum PRESCRIPTION_ADDED_BY {
  AUTO_UPLOAD = "AUTO_UPLOAD",
  PATIENT = "PATIENT",
}

export enum FEEDBACK {
  HC_REMOVES_COUPON = "HC_REMOVES_COUPON",
  NA = "NA",
  REMOVE_HC = "REMOVE_HC",
}

export enum OPT_SOURCE {
  APOLLO_PHARMACY_STORE = "APOLLO_PHARMACY_STORE",
  CALL_CENTER = "CALL_CENTER",
  CAMPAIGN = "CAMPAIGN",
  CAMPS = "CAMPS",
  CLINIC = "CLINIC",
  COMMUNITY_CHAMPION = "COMMUNITY_CHAMPION",
  OMT_TEAM = "OMT_TEAM",
  PARTNER = "PARTNER",
  WHATSAPP = "WHATSAPP",
}

export enum PrescriptionType {
  CONSULT = "CONSULT",
  LATER = "LATER",
  NA = "NA",
  UPLOADED = "UPLOADED",
}

export enum CorporateStatus {
  APPLICABLE = "APPLICABLE",
  APPLIED = "APPLIED",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}

export enum CartNudgeAction {
  CLOSE = "CLOSE",
  PROCEED = "PROCEED",
}

export enum CART_PAGE_CLICK {
  COUPONS = "COUPONS",
  DELIVERY = "DELIVERY",
}

export interface AddressInput {
  coordinate?: CoordinateInput | null;
  id?: string | null;
  zipcode?: string | null;
}

export interface BasePlanDetails {
  planId?: PLAN_ID | null;
  subPlanId?: string | null;
}

export interface CartInputDataV2 {
  address?: AddressInput | null;
  bankOffer?: boolean | null;
  cartSource?: CART_SOURCE | null;
  coupon?: string | null;
  feedback?: FEEDBACK | null;
  isHCPreferred?: boolean | null;
  isReminderSet?: boolean | null;
  medicineOrderCartLineItems?: (CartLineItemInputV2 | null)[] | null;
  patientId: any;
  prescriptionDetails?: (CartPrescriptionInputV2 | null)[] | null;
  prescriptionType?: PrescriptionType | null;
  subscription?: CartSubscriptionInputV2 | null;
  contactNumber?: string;
}

export interface CartLineItemInputV2 {
  isReminderSet?: boolean | null;
  medicineSKU: string;
  quantity: number;
  reminderDuration?: number | null;
  skuToReplace?: string | null;
}

export interface CartPrescriptionInputV2 {
  appointmentId?: string | null;
  documentId?: string | null;
  fileUrl?: string | null;
  meta?: PrescriptionMetaDataInput | null;
  prismFileId?: string | null;
  uhid?: string | null;
  isDelete?: boolean | null;
  hashedDocumentId?: string | null;
}

export interface CartSubscriptionInputV2 {
  circleAddedToCart?: boolean | null;
  planPurchaseDetails?: BasePlanDetails | null;
  subscriptionApplied?: boolean | null;
  userSubscriptionId?: string | null;
}

export interface CoordinateInput {
  latitude: number;
  longitude: number;
}

export interface PrescriptionMetaDataInput {
  createdAt?: string | null;
  doctorName?: string | null;
  fileName?: string | null;
  fileType?: string | null;
  medicineNames?: (string | null)[] | null;
  medicineSku?: (string | null)[] | null;
  patientName?: string | null;
}
